import { LIST_WIDTH, ARCHIVED_COLUMN } from 'utils/constants/listview';

export const columns = [
  ARCHIVED_COLUMN,
  {
    headerName: 'Employee ID',
    field: 'employeeId',
    width: LIST_WIDTH.HUMAN_READABLE_ID,
  },
  { headerName: 'Role', field: 'role', width: LIST_WIDTH.default },
  { headerName: 'Name', field: 'name', width: LIST_WIDTH.HUMAN_NAME },
  {
    headerName: 'Status',
    field: 'status',
    cellRenderer: 'activityComponent',
    width: LIST_WIDTH.STATUS,
  },
  {
    headerName: 'Assigned Site',
    field: 'assignedSite',
    width: LIST_WIDTH.lg,
  },
  {
    headerName: 'Departments',
    field: 'departments',
    width: LIST_WIDTH.xl,
  },
  {
    headerName: 'Phone',
    field: 'phone',
    width: LIST_WIDTH.PHONE_NUMBER,
  },
  { headerName: 'Email', field: 'email', width: LIST_WIDTH.xl },
];
